<template>
    <div ref="finger" class="finger">
        <div :class="{'finger-point-left': point === 'left', 'finger-point-right': point === 'right'}">
            <div class="tap-circle"></div>
            <div class="finger-graphic">
                <img :src="$getImg('image-editor/mobile-tutorial/finger.png')" alt="Finger" style="scale: 0.65">
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.tap-circle {
    position: absolute;
    top: 3px;
    left: 11px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: rgba(35, 187, 248, 0.69);
    opacity: 0;
}

.finger {
    position: relative;

    .finger-point-left {
        transform: rotate(-90deg) scaleX(-1);
    }

    .finger-point-right {
        transform: rotate(90deg) scaleX(1);
    }
}
</style>

<script>
export default {
    props: ['point'],
}
</script>
